import gjeFetch from 'gje-fetch';

import { Headers } from '../../constants/headers';
import hashGenerator from './hash-generator';

const sessionId = hashGenerator();

const getCsrfToken = (): string => {
    const csrfTokenElement = document.querySelector(
        'meta[name="csrf-token"]'
    ) as HTMLMetaElement;
    return csrfTokenElement && csrfTokenElement.content
        ? csrfTokenElement.content
        : '';
};

const getInterceptor = options => ({
    ...options,
    headers: {
        ...(options.headers || {}),
        [Headers.SESSION_ID]: sessionId,
        [Headers.REQUEST_ID]: hashGenerator()
    }
});

const defaultInterceptor = options => ({
    ...options,
    headers: {
        ...(options.headers || {}),
        [Headers.SESSION_ID]: sessionId,
        [Headers.REQUEST_ID]: hashGenerator(),
        [Headers.CSRF]: getCsrfToken()
    }
});

export default {
    configure() {
        gjeFetch.addRequestInterceptors(options => {
            return options.method === 'GET'
                ? getInterceptor(options)
                : defaultInterceptor(options);
        });
    }
};
